import { render, staticRenderFns } from "./referral.vue?vue&type=template&id=b1606680"
import script from "./referral.vue?vue&type=script&lang=js"
export * from "./referral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports